const adminService = { 
};

export default adminService;